module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjgyOSAzLjZsMi43IDIuN0w0LjExNCAxNi43MTQgMCAxOGwxLjQxNC0zLjk4NkwxMS44MyAzLjZ6TTE3LjQyLjU3OWMuNzcyLjc3MS43NzIgMS45MjggMCAyLjU3MWwtMS40MTQgMS40MTQtMi41NzEtMi41NzFMMTQuODUuNTc5Yy43NzEtLjc3MiAxLjkyOS0uNzcyIDIuNTcxIDB6IiBmaWxsPSIjOTk5OTk5IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/mycourses/EditGray.svg
// module id = 1734
// module chunks = 0